// eslint-disable-next-line import/prefer-default-export
export const singleElements = { // 幻灯片
  widthRatio: 0.1271, // PPT宽度占比 vw
  heightWidthRatio: 0.565, // 高宽比
  allWidthRatio: 0.3979, // 整个模版宽度占比 vw
  spacingRatio: 0.008, // 间距
};
